import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

export const formatWeightLotId = (lotId, prefix) => {
  if (lotId == null) return '-';
  return `${prefix}-${String(lotId).padStart(4, '0')}`;
};

export const WeightLotDropdown = ({
  selected,
  onChange,
  showAll = false,
  lots = null,
  name = "lot_id",
}) => {
  const { t } = useTranslation();
  const [localLots, setLocalLots] = useState([]);

  useEffect(() => {
    if (lots === null) {
      Fetch('api/data/lots?search_fields=type&search_values=weight', 'get', null, (data) => {
        const sorted = [...(data || [])].sort((a, b) => b.lot_id - a.lot_id);
        setLocalLots(sorted);
      });
    }
  }, [lots]);

  const lotsToDisplay = lots !== null ? lots : localLots;

  return (
    <select name={name} value={selected || ''} onChange={onChange}>
      {showAll  && <option value="">{t('all_weight_lots')}</option>}
      {!showAll && <option value="">{t('select_weight_lot')}</option>}
      {lotsToDisplay.map((lot) => (
        <option key={lot._id} value={lot.lot_id}>
          {formatWeightLotId(lot.lot_id, t('weight_lot_prefix'))}{lot.name ? ` — ${lot.name}` : ''}
        </option>
      ))}
    </select>
  );
};

export default WeightLotDropdown;
